import { ChakraProvider } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

import CurrentMeetingDataContextProvider from '@/features/meeting/context/CurrentMeetingDataContext';
import { SubscriptionManagerProvider } from '@/services/subscriptions/SubscriptionManagerContext';
import { theme } from '@/theme/theme';
import { StandaloneModalProvider } from '@/ui/StandaloneModal/StandaloneModalProvider';

export const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <ChakraProvider theme={theme}>
      <StandaloneModalProvider>
        <SubscriptionManagerProvider>
          <CurrentMeetingDataContextProvider>{children}</CurrentMeetingDataContextProvider>
        </SubscriptionManagerProvider>
      </StandaloneModalProvider>
    </ChakraProvider>
  );
};
